import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const GoogleAIStudioTutorial = lazy(() => import('../pages/blog/tutorials/GoogleAIStudio'));
const GroqTutorial = lazy(() => import('../pages/blog/tutorials/Groq'));
const GrokTutorial = lazy(() => import('../pages/blog/tutorials/Grok'));
const OpenRouterTutorial = lazy(() => import('../pages/blog/tutorials/OpenRouter'));
const ATSPlatformsPage = lazy(() => import('../pages/ats-platforms/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsOfServicePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/google-ai-studio-free-api-key',
    element: <GoogleAIStudioTutorial />,
  },
  {
    path: '/blog/groq-free-api-key',
    element: <GroqTutorial />,
  },
  {
    path: '/blog/grok-free-api-key',
    element: <GrokTutorial />,
  },
  {
    path: '/blog/openrouter-free-api-key',
    element: <OpenRouterTutorial />,
  },
  {
    path: '/ats-platforms',
    element: <ATSPlatformsPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;